/**
 * For the pages whose URLs name the language being learned (/es/myTexts,
 * /es/library, /es/links): their titles, and following the language as it
 * changes.
 */
import $ from "jquery";

import type { AppRouterLike } from "AppRouter";
import * as languageMap from "shared/languageMap";
import stores from "stores/stores";

/** Titles the page, in the language being learned, for browsers and search engines */
export const setTitle = (
  title: string,
  description: (languageName: string) => string
) => {
  const languageName =
    languageMap.map[stores.user.currentLearningLanguage.value].english;
  $("title").text(`${title} - ${languageName} - Readlang`);
  $('meta[name="description"]').attr("content", description(languageName));
};

/** Moves the page to the language being learned as it changes: returns the disposer */
export const follow = (appRouter: AppRouterLike) =>
  stores.user.onChange(
    (user) => user.currentLearningLanguage,
    (language) => {
      // Assuming any path starting with a two or three letter segment names the language
      appRouter.navigate(
        window.location.pathname.replace(/^\/(\w\w\w?)\//, `/${language}/`),
        { trigger: true }
      );
    }
  );
